import { supabase } from './supabase';

export const profileService = {
  // Get the current user's profile
  async getProfile(userId) {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error fetching profile:', error);
      return { data: null, error };
    }

    return { data, error: null };
  },

  // Update the current user's profile
  async updateProfile(userId, updates) {
    const { data, error } = await supabase
      .from('profiles')
      .update({
        ...updates,
        updated_at: new Date().toISOString()
      })
      .eq('id', userId)
      .select()
      .single();

    if (error) {
      console.error('Error updating profile:', error);
      return { data: null, error };
    }

    return { data, error: null };
  },

  // Create a profile (usually handled by trigger, but this is a fallback)
  async createProfile(userId, email, displayName = null) {
    const { data, error } = await supabase
      .from('profiles')
      .insert({
        id: userId,
        email,
        display_name: displayName
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating profile:', error);
      return { data: null, error };
    }

    return { data, error: null };
  },

  // Ensure profile exists (creates if missing)
  async ensureProfile(user) {
    if (!user) return { data: null, error: 'No user provided' };

    // First try to get the profile
    const { data: existingProfile, error: fetchError } = await this.getProfile(user.id);
    
    if (existingProfile) {
      return { data: existingProfile, error: null };
    }

    // If profile doesn't exist, create it
    if (fetchError?.code === 'PGRST116') { // Profile not found
      return await this.createProfile(user.id, user.email, user.user_metadata?.display_name);
    }

    return { data: null, error: fetchError };
  }
};